import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Music2, Mail, Phone, MapPin, GraduationCap } from "lucide-react";
import { useSettings } from "../lib/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <footer data-testid="main-footer" className="bg-[#071224] text-slate-300 relative overflow-hidden">
      <div className="absolute inset-0 papua-pattern-dark opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center overflow-hidden ${s.logo_url ? "bg-white p-1.5 ring-2 ring-amber-400/40" : "bg-[#0B1D3A] border border-amber-500/30"}`}>
                {s.logo_url ? (
                  <img src={s.logo_url} alt="Logo SMAS YPK 2 BIAK" className="w-full h-full object-contain" />
                ) : (
                  <GraduationCap className="text-amber-400" strokeWidth={1.5} />
                )}
              </div>
              <div>
                <div className="font-serif font-bold text-white">SMAS YPK 2 BIAK</div>
                <div className="text-[11px] tracking-[0.18em] text-amber-400 font-semibold">AKREDITASI A</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Mencetak Generasi GARAM — Berakhlak Kristiani, Responsif, Apikal (Unggul), dan Mandiri — Berwawasan Global di Tanah Papua sejak 1991.
            </p>
            <div className="mt-5 flex gap-3">
              <a href={s.instagram || "#"} target="_blank" rel="noopener noreferrer" aria-label="Instagram @smayda_biak" data-testid="footer-instagram" className="w-9 h-9 rounded-full bg-white/5 hover:bg-amber-500/20 border border-white/10 flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href={s.facebook || "#"} target="_blank" rel="noopener noreferrer" aria-label="Facebook @SmaydaBiak" data-testid="footer-facebook" className="w-9 h-9 rounded-full bg-white/5 hover:bg-amber-500/20 border border-white/10 flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
              <a href={s.youtube || "#"} target="_blank" rel="noopener noreferrer" aria-label="YouTube @smaypk2biak" data-testid="footer-youtube" className="w-9 h-9 rounded-full bg-white/5 hover:bg-amber-500/20 border border-white/10 flex items-center justify-center transition-colors"><Youtube className="w-4 h-4" /></a>
              {s.tiktok && !s.tiktok.includes("[") && (
                <a href={s.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="w-9 h-9 rounded-full bg-white/5 hover:bg-amber-500/20 border border-white/10 flex items-center justify-center transition-colors"><Music2 className="w-4 h-4" /></a>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-amber-400 text-xs font-bold uppercase tracking-[0.22em] mb-5">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/tentang-kami" className="hover:text-amber-400 transition-colors">Tentang Kami</Link></li>
              <li><Link to="/akademik" className="hover:text-amber-400 transition-colors">Akademik</Link></li>
              <li><Link to="/prestasi" className="hover:text-amber-400 transition-colors">Prestasi</Link></li>
              <li><Link to="/berita" className="hover:text-amber-400 transition-colors">Berita</Link></li>
              <li><Link to="/ppdb" className="hover:text-amber-400 transition-colors">PPDB</Link></li>
              <li><Link to="/galeri" className="hover:text-amber-400 transition-colors">Galeri</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-400 text-xs font-bold uppercase tracking-[0.22em] mb-5">Informasi</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/pengumuman" className="hover:text-amber-400 transition-colors">Pengumuman</Link></li>
              <li><Link to="/kalender" className="hover:text-amber-400 transition-colors">Kalender Sekolah</Link></li>
              <li><Link to="/download-center" className="hover:text-amber-400 transition-colors">Pusat Unduhan</Link></li>
              <li><Link to="/guru" className="hover:text-amber-400 transition-colors">Guru & Staf</Link></li>
              <li><Link to="/fasilitas" className="hover:text-amber-400 transition-colors">Fasilitas</Link></li>
              <li><Link to="/kontak" className="hover:text-amber-400 transition-colors">Kontak</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-400 text-xs font-bold uppercase tracking-[0.22em] mb-5">Hubungi Kami</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><MapPin className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-400" /><span className="text-slate-400 leading-relaxed">{s.address || "JL. Yos Sudarso No. 31, Biak Numfor, Papua"}</span></li>
              <li className="flex gap-3"><Mail className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-400" /><a href={`mailto:${s.email}`} className="text-slate-400 hover:text-amber-400">{s.email || "ypkbiaksma@gmail.com"}</a></li>
              <li className="flex gap-3"><Phone className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-400" /><span className="text-slate-400">{s.phone || "[ISI DATA SEKOLAH]"}</span></li>
            </ul>
          </div>
        </div>

        <div className="gold-rule mt-14 opacity-40" />
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <span>© 2026 SMAS YPK 2 BIAK. All Rights Reserved.</span>
          <span>Dibangun dengan dedikasi untuk pendidikan Papua.</span>
        </div>
      </div>
    </footer>
  );
}
